export function broadcastBlockLoad(blockClassName) {
    var _a;
    var _BUS = window && window["sbMsgBus"];
    var pref = _BUS && _BUS.sbPrefix || "sb_";
    if (_BUS && typeof _BUS.post === "function") {
        _BUS.post((_a = {}, _a["" + pref + blockClassName + "_loaded"] = true, _a));
    }
}
//# sourceMappingURL=BroadcastBlockLoad.js.map